import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Spinner,
  Accordion,
  Modal,
  Button,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getpackage } from "../../store/slices/package";
import PackagePDF from "./Packagepdf";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import { FaMapMarkerAlt, FaCalendarAlt, FaUsers } from "react-icons/fa";
import {
  FaHotel,
  FaBullseye,
  FaCheckSquare,
  FaStar,
  FaCar,
} from "react-icons/fa";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { MdArrowRightAlt } from "react-icons/md";
import { getuserProfile } from "../../store/slices/auth";

export default function PackageDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!profile) {
      dispatch(getuserProfile());
    }
  }, [dispatch, profile]);


  const { packageList = [], loading } = useSelector((state) => state.package);
  const [pdfLoading, setPdfLoading] = useState(false);
  const packagedata = packageList;
  const [activeImage, setActiveImage] = useState(0);
  const [fade, setFade] = useState(true);


  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (packagedata?.options?.length) {
      const defaultOption =
        packagedata.options.find((opt) => opt.isDefault) ||
        packagedata.options[0];

      setSelectedOption(defaultOption);
    }
  }, [packagedata]);

  const [showAllHotels, setShowAllHotels] = useState(false);

  const visibleHotels =
    packagedata?.hotels?.filter(
      (hotel) => hotel.packageOption?._id === selectedOption?._id,
    ) || [];

  const visibleVehicles =
    packagedata?.vehicles?.filter(
      (vehicle) => vehicle.packageOption?._id === selectedOption?._id,
    ) || [];

  const visibleActivities =
    packagedata?.activities?.filter(
      (activity) => activity.packageOption?._id === selectedOption?._id,
    ) || [];

  const visibleFerries =
    packagedata?.ferrys?.filter(
      (ferry) =>
        !selectedOption || ferry.packageOption?._id === selectedOption?._id,
    ) || [];
  const ferryList = visibleFerries.flatMap((group) => group.ferries || []);

  //  Hotel <---
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [showHotelModal, setShowHotelModal] = useState(false);

  const handleHotelClick = (hotel) => {
    setSelectedHotel(hotel);
    setShowHotelModal(true);
  };

  //  Vehicle -- >
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showVehicleModal, setShowVehicleModal] = useState(false);

  const handleVehicleClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowVehicleModal(true);
  };

  // Activity <---
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [showActivityModal, setShowActivityModal] = useState(false);

  const handleActivityClick = (activity) => {
    setSelectedActivity(activity);
    setShowActivityModal(true);
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(getpackage({ id }));
  }, [dispatch, id]);

  const handleImageChange = (index) => {
    setFade(false);
    setTimeout(() => {
      setActiveImage(index);
      setFade(true);
    }, 150);
  };

  if (loading || !packagedata?._id) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  // images , single or multiple img
  const images = Array.isArray(packagedata?.image)
    ? packagedata.image
    : packagedata?.image
      ? [packagedata.image]
      : [];

  // for dayplans , content
  const getTimelineItems = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    return Array.from(doc.querySelectorAll("p"))
      .map((p) => p.textContent.trim())
      .filter((text) => text !== "" && text !== "\u00A0");
  };

  // remove number and hyphen ------- >
  const cleanedInclusions = packagedata.inclusions?.replace(
    /(<strong>)\s*\d+\s*-\s*/g,
    "$1",
  );

  const cleanedExclusions = packagedata.exclusions?.replace(
    /(<strong>)\s*\d+\s*-\s*/g,
    "$1",
  );

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator"> | </span>
          <Link to="/admin/packages" className="breadcrumb-link active">
            Packages
          </Link>
          <span className="breadcrumb-separator"> | </span>
          <span className="breadcrumb-link inactive">Package Details</span>
        </div>
      </div>

      <Container fluid className="my-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center my-2">
          {/* basic and Premium  */}
          <Row className="mb-4 mt-3 justify-content-center">
            <Col md="auto">
              <div className="toggle-wrapper">
                {packagedata?.options?.length > 1 && (
                  <div
                    className="toggle-slider"
                    style={{
                      width: `${100 / packagedata.options.length}%`,
                      transform: `translateX(${packagedata.options.findIndex(
                        (o) => o._id === selectedOption?._id,
                      ) * 100
                        }%)`,
                    }}
                  />
                )}

                {packagedata?.options?.map((option) => (
                  <button
                    key={option._id}
                    className={`toggle-item ${selectedOption?.name === option.name ? "active-text" : ""
                      }`}
                    onClick={() => setSelectedOption(option)}
                  >
                    {option.name}
                  </button>
                ))}
              </div>
            </Col>
          </Row>

          <button
            className="add-outlet-btn"
            disabled={!packagedata || pdfLoading}
            onClick={async () => {
              if (!packagedata || pdfLoading) return;

              try {
                setPdfLoading(true);

                const doc = (
                  <PackagePDF
                    data={packagedata}
                    profile={profile}
                  />
                );

                const blob = await pdf(doc).toBlob();

                if (!blob) {
                  console.error("PDF generation failed");
                  setPdfLoading(false);
                  return;
                }

                const url = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = `${packagedata.title || "package"}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(url);
              } catch (error) {
                console.error("PDF Error:", error);
              } finally {
                setPdfLoading(false);
              }
            }}
          >
            {pdfLoading ? "Preparing PDF..." : "Download"}
          </button>
        </div>

        {/* <div className="col-md-12">
          {packagedata && (
            <div style={{ height: "800px", marginTop: "40px" }}>
              <PDFViewer width="100%" height="100%">
                <PackagePDF
                  data={packagedata}
                  profile={profile}
                />
              </PDFViewer>
            </div>
          )}
        </div> */}
        <Card
          className="p-3 p-md-4"
          style={{
            borderRadius: "25px",
            border: "none",
          }}
        >
          <Row className="g-4 align-items-stretch">
            <Card className="border-0 shadow-lg text-white overflow-hidden responsive-card">
              {images.length > 0 && (
                <div
                  className="bg-image"
                  style={{
                    backgroundImage: `url(${images[activeImage] || images[0]})`,
                  }}
                />
              )}

              <div className="bg-overlay" />

              <Card.Body className="content-area">
                <div className="mb-4">
                  <span className="featured-badge">
                    {packagedata?.category?.name}
                  </span>
                </div>

                <h1 className="fw-bold title-text">{packagedata.title}</h1>

                <div className="pill-row">
                  <span className="info-pill">
                    <FaMapMarkerAlt className="me-2" />
                    {packagedata.places?.map((p) => p.name).join(", ")}
                  </span>

                  <span className="info-pill">
                    <FaCalendarAlt className="me-2" />
                    {packagedata.durationNights} Nights/{" "}
                    {packagedata.durationDays} Days
                  </span>

                  <span className="info-pill">
                    <FaUsers className="me-2" />2 Adults
                  </span>
                </div>

                <div className="price-container">
                  <div className="price">
                    ₹ {selectedOption?.sellingPricePerPerson}
                  </div>

                  <div className="per-person">per person</div>
                </div>
              </Card.Body>

              {/* Thumbnails */}
              {images.length > 1 && (
                <div className="thumbnail-container">
                  {images.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt="thumb"
                      onClick={() => handleImageChange(i)}
                      className={`thumbnail ${activeImage === i ? "active-thumb" : ""
                        }`}
                    />
                  ))}
                </div>
              )}
            </Card>
          </Row>

          {/* price and basic and premium taggle */}
          <Row className="justify-content-center mt-3">
            <Col lg={12} md={12}>
              <div
                style={{
                  background: "linear-gradient(135deg,#3b0f6f,#5a1ea1)",
                  borderRadius: "18px",
                  padding: "18px 24px",
                  color: "white",
                }}
              >
                <Row className="align-items-center">
                  <Col md={4}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          background: "#22c55e",
                        }}
                      />

                      <div>
                        <div style={{ fontWeight: "600", fontSize: "18px" }}>
                          {selectedOption?.name} Package Price
                        </div>

                        <div style={{ opacity: "0.8", fontSize: "14px" }}>
                          ₹ {selectedOption?.sellingPricePerPerson} per pax •
                          Total ₹ {selectedOption?.sellingPricePerPerson * 2} for{" "}
                          {selectedOption?.basePax} pax
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={8} className="text-md-end mt-3 mt-md-0">
                    {/* basic and Premium  */}
                    <Row className="mb-4 mt-3 justify-content-center">
                      <Col md="auto">
                        <div className="toggle-wrapper">
                          {packagedata?.options?.length > 1 && (
                            <div
                              className="toggle-slider"
                              style={{
                                width: `${100 / packagedata.options.length}%`,
                                transform: `translateX(${packagedata.options.findIndex(
                                  (o) => o.name === selectedOption?.name,
                                ) * 100
                                  }%)`,
                              }}
                            />
                          )}

                          {packagedata?.options?.map((option) => (
                            <button
                              key={option._id}
                              className={`toggle-item ${selectedOption?.name === option.name
                                ? "active-text"
                                : ""
                                }`}
                              onClick={() => setSelectedOption(option)}
                            >
                              {option.name}
                            </button>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* couting Row */}
          <Row className="g-4 mb-4 my-4">
            {/* Hotels */}
            <Col md={6} lg={3}>
              <Card className="stats-card hotel-card shadow-sm border-0">
                <Card.Body className="d-flex align-items-center gap-3">
                  <div className="stats-icon hotel-icon">
                    <FaHotel />
                  </div>
                  <div>
                    <h3 className="stats-number">
                      {visibleHotels?.length || 0}
                    </h3>
                    <div className="stats-label">Hotels Included</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Activities */}
            <Col md={6} lg={3}>
              <Card className="stats-card activity-card shadow-sm border-0">
                <Card.Body className="d-flex align-items-center gap-3">
                  <div className="stats-icon activity-icon">
                    <FaBullseye />
                  </div>
                  <div>
                    <h3 className="stats-number">
                      {visibleActivities?.length || 0}
                    </h3>
                    <div className="stats-label">Activities Planned</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Bookings */}
            <Col md={6} lg={3}>
              <Card className="stats-card booking-card shadow-sm border-0">
                <Card.Body className="d-flex align-items-center gap-3">
                  <div className="stats-icon booking-icon">
                    <FaCheckSquare />
                  </div>
                  <div>
                    <h3 className="stats-number">24</h3>
                    <div className="stats-label">Bookings Made</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Avg Rating */}
            <Col md={6} lg={3}>
              <Card className="stats-card rating-card shadow-sm border-0">
                <Card.Body className="d-flex align-items-center gap-3">
                  <div className="stats-icon rating-icon">
                    <FaStar />
                  </div>
                  <div>
                    <h3 className="stats-number">4.9</h3>
                    <div className="stats-label">Avg. Rating</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Description */}
          <Row className="my-4">
            <Col sm={12} md={12} lg={12}>
              <div className="package-description mt-4 p-4">
                <h5 className="desc-title mb-3">Package Overview</h5>

                <div
                  className="desc-content"
                  dangerouslySetInnerHTML={{
                    __html: packagedata.description,
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className="g-4 mb-4">
            <Col lg={7} md={12}>
              <Card className="itinerary-card border-0 shadow-sm rounded-4">
                <Card.Body className="p-2">
                  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <h4 className="fw-bold itinerary-title mb-0 d-flex justify-content-center align-items-center  gap-1">
                      Day-by-Day Itinerary
                    </h4>

                    <span className="days-badge">
                      {packagedata.durationDays} Days
                    </span>
                  </div>

                  <Accordion flush>
                    {packagedata.dayPlans?.map((day, index) => (
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={day._id}
                        className="itinerary-item"
                      >
                        <Accordion.Header>
                          <div className="d-flex align-items-center gap-3 w-100">
                            <div className="day-box">{day.dayNumber}</div>
                            <div className="flex-grow-1 text-start">
                              <div className="fw-semibold">{day.title}</div>
                            </div>
                          </div>
                        </Accordion.Header>

                        <Accordion.Body>
                          <div className="timeline">
                            {getTimelineItems(day.description).map(
                              (item, index) => (
                                <div className="timeline-item" key={index}>
                                  <div className="timeline-dot"></div>

                                  <div className="timeline-text">
                                    {item.replace(/^\d+-/, "")}
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </Card.Body>
              </Card>
            </Col>

            {/* Hotels */}
            <Col lg={5} md={12}>
              <Card className="hotel-section border-0 shadow-sm rounded-4">
                <Card.Body className="p-4">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <div className="hotel-icon-box">🏨</div>
                      <h5 className="fw-bold mb-0 hotel-title">Hotels</h5>
                    </div>

                    <span className="option-badge">
                      {visibleHotels?.length || 0} options
                    </span>
                  </div>

                  {/* Hotel Grid */}
                  <Row className="g-4 hotel-scroll">
                    {visibleHotels?.map((hotelItem, index) => (
                      <Col
                        lg={index % 3 === 2 ? 12 : 6}
                        md={6}
                        sm={12}
                        key={hotelItem._id}
                      >
                        <Card
                          className="hotel-card border-0 shadow-sm rounded-4 h-100"
                          onClick={() => handleHotelClick(hotelItem)}
                        >
                          <Card.Img
                            variant="top"
                            src={hotelItem.hotel?.image}
                            className="hotel-img"
                          />

                          <Card.Body>
                            <h6 className="fw-bold hotel-name">
                              {hotelItem.hotel?.name}
                            </h6>

                            <div className="text-muted small mb-1">
                              {hotelItem.hotel?.location?.name}
                            </div>

                            <div className="text-muted small mb-3">
                              {hotelItem.roomType?.name}
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                              <span className="night-badge small">
                                {hotelItem.nights} Night
                              </span>

                              <span className="hotel-price">
                                ₹{hotelItem.roomPrice}
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>

                  {/* Expand Button */}
                  {packagedata.hotels?.length > 3 && (
                    <div className="text-center mt-4">
                      <button
                        className="submit-btn"
                        onClick={() => setShowAllHotels(!showAllHotels)}
                      >
                        {showAllHotels ? "Show Less" : "Show All Hotels"}
                      </button>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* vehicles and activity  */}

          <Row className="g-4 my-3">
            <Col lg={6} md={12} className="my-2">
              <Card className="vehicle-section border-0 shadow-sm rounded-4">
                <Card.Body className="p-3">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <div className="vehicle-icon-box">
                        <FaCar size={20} />
                      </div>

                      <h5 className="fw-bold mb-0 vehicle-title">Vehicles</h5>
                    </div>

                    <span className="option-badge">
                      {visibleVehicles.length || 0} options
                    </span>
                  </div>

                  {/* Vehicle Grid */}
                  <Row className="g-4">
                    {visibleVehicles?.map((vehicle) => (
                      <Col lg={6} md={6} sm={12} key={vehicle._id}>
                        <Card
                          className="vehicle-card border-0 shadow-sm rounded-4 h-100"
                          onClick={() => handleVehicleClick(vehicle)}
                        >
                          <Card.Body
                            style={{
                              border: "1px solid #3c1361",
                              borderRadius: "15px",
                            }}
                          >
                            {/* Vehicle Name */}
                            <h6 className="fw-bold vehicle-name mb-1">
                              {vehicle.vehicleType?.name}
                            </h6>

                            {/* Price Per Day */}
                            <div className="purple-color mb-2 fw-semibold">
                              <FaIndianRupeeSign className="me-1" />
                              {vehicle?.pricePerDay} / Per day
                            </div>

                            {/* Features */}
                            <div className="vehicle-feature-wrapper">
                              <span className="vehicle-badge">
                                {vehicle.vehicleType?.capacity} Seats
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* Activity */}
            <Col lg={6} md={12} className="my-2">
              <Card className="activity-section border-0 shadow-sm rounded-4">
                <Card.Body className="p-4">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <h5 className="fw-bold mb-0 activity-title">
                        Activities
                      </h5>
                    </div>

                    <span className="option-badge">
                      {visibleActivities.length || 0} options
                    </span>
                  </div>

                  {/* Activities Grid */}
                  <Row className="g-4">
                    {visibleActivities?.map((activityGroup) =>
                      activityGroup.activities?.map((activityItem) => (
                        <Col lg={6} md={6} sm={12} key={activityItem._id}>
                          <Card
                            className="activity-card border-0 shadow-sm rounded-4 h-100"
                            onClick={() => handleActivityClick(activityItem)}
                          >
                            <Card.Body
                              style={{
                                border: "1px solid #3c1361",
                                borderRadius: "15px",
                              }}
                            >
                              {/* Activity Name */}
                              <h6 className="fw-bold activity-name mb-1">
                                {activityItem.activity?.name}
                              </h6>

                              {/* Vendor Name */}
                              <div className="text-muted small mb-2">
                                {activityItem.vendor?.name}
                              </div>

                              {/* Badges */}
                              <div className="activity-feature-wrapper">
                                <span
                                  className={`activity-badge ${activityItem.isIncluded
                                    ? "included-badge"
                                    : "notincluded-badge"
                                    }`}
                                >
                                  {activityItem.timing}
                                </span>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      )),
                    )}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Ferry ------ >  */}

          <Row>
            <Col lg={12} md={12} className="my-2">
              <Card className="activity-section border-0 shadow-sm rounded-4">
                <Card.Body className="p-4">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <h5 className="fw-bold mb-0 activity-title">Ferries</h5>
                    </div>

                    <span className="option-badge">
                      {visibleFerries?.length || 0} options
                    </span>
                  </div>

                  <Row className="g-4">
                    {ferryList.map((ferryItem) => (
                      <Col lg={6} md={6} sm={12} key={ferryItem._id}>
                        <Card className="activity-card border-0 shadow-sm rounded-4 h-100">
                          <Card.Body
                            style={{
                              borderLeft: "1px solid #2d0c57",
                              borderTop: "1px solid #2d0c57",
                              borderBottom: "1px solid #2d0c57",
                              borderRadius: "20px",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fw-semibold">
                                {ferryItem.fromPlace?.name}
                              </span>

                              <span>
                                {ferryItem.departureTime}
                                <MdArrowRightAlt size={25} className="mx-2" />
                                {ferryItem.arrivalTime}
                              </span>

                              <span className="fw-semibold">
                                {ferryItem.toPlace?.name}
                              </span>
                            </div>

                            <div className="text-center mt-2">
                              ⏱ {ferryItem.duration}
                            </div>

                            <div className="d-flex justify-content-between mt-2">
                              <span>{ferryItem.ferry?.name}</span>

                              <span className="activity-badge">
                                {ferryItem.className}
                              </span>

                              <span className="fw-bold">
                                ₹{ferryItem.price}
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* inclustion and exclution */}
          <Row className="mt-4">
            {/* Inclusions  <---- */}
            <Col md={12} lg={6} sm={12} className="d-flex">
              <Card className="info-card inclusions-card w-100 p-4 my-1">
                <h5 className="card-title mb-3"> Inclusions</h5>

                <div className="timeline">
                  <div
                    className="timeline-items"
                    dangerouslySetInnerHTML={{
                      __html: cleanedInclusions,
                    }}
                  />
                </div>
              </Card>
            </Col>

            {/* Exclusions ---- > */}
            <Col md={12} lg={6} sm={12} className="d-flex">
              <Card className="info-card exclusions-card w-100 p-4 my-1">
                <h5 className="card-title mb-3"> Exclusions</h5>
                <div className="timeline">
                  <div
                    className="timeline-items"
                    dangerouslySetInnerHTML={{
                      __html: cleanedExclusions,
                    }}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </Card>
      </Container>

      {/* Hotel Popup */}
      <Modal
        show={showHotelModal}
        onHide={() => setShowHotelModal(false)}
        centered
        contentClassName="border-0  bg-transparent shadow-none"
        className="my-4"
        style={{ border: "none" }}
      >
        <Modal.Body
          className="p-4"
          style={{
            borderRadius: "30px",
            background: "linear-gradient(180deg, #4b1e78, #8e7aa6)",
            border: "6px solid rgba(255,255,255,0.35)",
            backdropFilter: "blur(10px)",
          }}
        >
          {selectedHotel && (
            <>
              {/* Close Button */}
              <div className="d-flex justify-content-end">
                <Button
                  variant="light"
                  onClick={() => setShowHotelModal(false)}
                  style={{
                    borderRadius: "70%",
                    width: "35px",
                    height: "35px",
                    padding: "0",
                    fontWeight: "bold",
                  }}
                >
                  ✕
                </Button>
              </div>

              {/* Hotel Title */}
              <div className="text-start  text-white mb-4">
                <h4 className="fw-bold mb-2">{selectedHotel.hotel?.name}</h4>
                <div className="opacity-75">{selectedHotel.roomType?.name}</div>
              </div>

              {/* Image */}
              <img
                src={selectedHotel.hotel?.image}
                alt="hotel"
                className="w-100 rounded-4 mb-4"
                style={{
                  height: "220px",
                  objectFit: "cover",
                }}
              />

              {/* Details */}
              <Row className="text-white mb-3">
                <Col xs={6}>
                  <div className="fw-semibold">Nights</div>
                  <div>{selectedHotel.nights}</div>
                </Col>

                <Col xs={6} className="text-end">
                  <div className="fw-semibold">Room Price</div>
                  <div className="fw-bold fs-5">₹{selectedHotel.roomPrice}</div>
                </Col>
              </Row>

              <Row className="text-white">
                <Col xs={6}>
                  <div className="fw-semibold">Extra Beds</div>
                  <div>{selectedHotel.extraBeds}</div>
                </Col>

                <Col xs={6} className="text-end">
                  <div className="fw-semibold">Extra Bed Price</div>
                  <div>₹{selectedHotel.extraBedPrice}</div>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* Vehicle Popup */}
      <Modal
        show={showVehicleModal}
        onHide={() => setShowVehicleModal(false)}
        centered
        contentClassName="border-0 bg-transparent shadow-none"
        className="my-4"
      >
        <Modal.Body
          className="p-4"
          style={{
            borderRadius: "30px",
            background: "linear-gradient(180deg, #4b1e78, #8e7aa6)",
            border: "6px solid rgba(255,255,255,0.35)",
          }}
        >
          {selectedVehicle && (
            <>
              {/* Close Button */}
              <div className="d-flex justify-content-end">
                <Button
                  variant="light"
                  onClick={() => setShowVehicleModal(false)}
                  style={{
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    padding: "0",
                    fontWeight: "bold",
                  }}
                >
                  ✕
                </Button>
              </div>

              {/* Title */}
              <div className="text-center text-white mb-4">
                <h4 className="fw-bold mb-2">
                  {selectedVehicle.vehicleType?.name}
                </h4>
                <div className="opacity-75">
                  {selectedVehicle.vehicleType?.description}
                </div>
              </div>

              {/* Details Row */}
              <Row className="text-white mb-3">
                <Col xs={6}>
                  <div className="fw-semibold">Capacity</div>
                  <div>{selectedVehicle.vehicleType?.capacity}</div>
                </Col>

                <Col xs={6} className="text-end">
                  <div className="fw-semibold">Fuel Type</div>
                  <div>{selectedVehicle.vehicleType?.fuelType}</div>
                </Col>
              </Row>

              <Row className="text-white">
                <Col xs={6}>
                  <div className="fw-semibold">AC</div>
                  <div>{selectedVehicle.vehicleType?.ac ? "Yes" : "No"}</div>
                </Col>

                <Col xs={6} className="text-end">
                  <div className="fw-semibold">Remarks</div>
                  <div>{selectedVehicle.remarks || "—"}</div>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* Activity */}
      <Modal
        show={showActivityModal}
        onHide={() => setShowActivityModal(false)}
        centered
        contentClassName="border-0 bg-transparent shadow-none"
        className="my-4"
      >
        <Modal.Body
          className="p-4"
          style={{
            borderRadius: "30px",
            background: "linear-gradient(180deg, #4b1e78, #8e7aa6)",
            border: "6px solid rgba(255,255,255,0.35)",
          }}
        >
          {selectedActivity && (
            <>
              {/* Close Button */}
              <div className="d-flex justify-content-end">
                <Button
                  variant="light"
                  onClick={() => setShowActivityModal(false)}
                  style={{
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    padding: "0",
                    fontWeight: "bold",
                  }}
                >
                  ✕
                </Button>
              </div>

              {/* Title */}
              <div className="text-center text-white mb-4">
                <h4 className="fw-bold mb-2">
                  {selectedActivity.activity?.name}
                </h4>
                <div className="opacity-75">
                  Vendor: {selectedActivity.vendor?.name}
                </div>
              </div>

              {/* Details */}
              <Row className="text-white mb-3">
                <Col xs={6}>
                  <div className="fw-semibold">Included</div>
                  <div>{selectedActivity.isIncluded ? "Yes" : "No"}</div>
                </Col>

                <Col xs={6} className="text-end">
                  <div className="fw-semibold">Vendor</div>
                  <div>{selectedActivity.vendor?.name}</div>
                </Col>
              </Row>

              <Row className="text-white">
                <Col>
                  <div className="fw-semibold">Description</div>
                  <div className="small opacity-75">
                    {selectedActivity.activity?.description || "—"}
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
